import { FaRegUserCircle } from "react-icons/fa";
import { AiFillProduct } from "react-icons/ai";
import { MdCategory } from "react-icons/md";
import { GiVerticalBanner } from "react-icons/gi";
import { IoIosSettings } from "react-icons/io";
import {RiAdminFill, RiAdvertisementFill, RiDashboard2Line} from "react-icons/ri";
import { FaComments } from "react-icons/fa6";
import { LuCircleUserRound } from "react-icons/lu";
import { FaFileInvoice } from "react-icons/fa6";
import { RiSecurePaymentLine } from "react-icons/ri";
import {BiSolidOffer} from "react-icons/bi";




export const dataSidebar = [


    {
        link: "/",
        title: "Dashboard",
        icon: <RiDashboard2Line/>,


    },
    {
        title: "Site Banner",
        icon: <GiVerticalBanner/>,
        subItem : [
            {
                link: "/all-banner",
                title: "All Banner",
                icon: <AiFillProduct/>,
            },
            {
                link: "/multi-banner",
                title: "Multi Banner",
                icon: <AiFillProduct/>,
            },
            {
                link: "/create-banner",
                title: "Create Banner",
                icon: <AiFillProduct/>,
            },
        ]

    },
    {
        link: "/user",
        title: "Users",
        icon: <FaRegUserCircle/>,

    },
    {
        link: "/my-product",
        title: "Product",
        icon: <AiFillProduct/>,
        // subItem : [
        //     {
        //         link: "/my-product",
        //         title: "My Product",
        //         icon: <AiFillProduct/>,
        //     }, {
        //         link: "/seller-product",
        //         title: "Seller Product",
        //         icon: <AiFillProduct/>,
        //     },
        //
        // ]

    },
    {
        link: "/category",
        title: "Category",
        icon: <MdCategory/>,

    },
    {
        link: "/comment",
        title: "Comment",
        icon: <FaComments/>,

    },
    {
        link: "/invoice",
        title: "Invoice",
        icon: <FaFileInvoice/>,

    },
    {
        link: "/payment-methode",
        title: "Payment Method",
        icon: <RiSecurePaymentLine/>,

    },
    {
        link: "/Setting",
        title: "Setting",
        icon: <IoIosSettings/>,

    },
    {
        link: "/admins",
        title: "Admins",
        icon: <RiAdminFill/>,
    },
    {
        title: "Advertisements",
        icon: <RiAdvertisementFill/>,
        subItem : [
            {
                link: "/offerManagement",
                title: "Special Offers",
                icon: <BiSolidOffer/>,
            },
            {
                link: "/wonderfulManagement",
                title: "Wonderful Offers",
                icon: <BiSolidOffer/>,
            },
        ]

    }
]